import * as React from "react";
import { MailTreeIcon, TreeItem, DriveMessages, TreeItemType, DriveEntryIcons } from "src/common";
import { Icon } from "src/components";

type AllProps = {
    folder: TreeItem;
    open: boolean;
    fetching_children?: boolean;
    empty_tooltip?: string;
    is_flat?: boolean;
};

// Description: Render Side icons conditionally
function TreeFolderIcon(props: AllProps) {
    const { folder, open, fetching_children, empty_tooltip, is_flat } = props;
    return <>
        {
            (folder.children_loading && open && fetching_children) ?
                <>
                    <Icon className="spinner" />
                    <Icon tooltip={folder.name}
                        className={`${folder.type === TreeItemType.folder ? DriveEntryIcons.Folder : DriveEntryIcons.Shared_Folder} ${folder.starred ? DriveEntryIcons.Starred : ""}`} />
                </> : <>
                    {
                        !is_flat && <Icon className={(open && !!folder.children) ? MailTreeIcon.opened : MailTreeIcon.closed} />
                    }
                    <Icon tooltip={!folder.children && !folder.children_loading ?
                        (!!empty_tooltip ? empty_tooltip : DriveMessages.tree_folder_empty) : folder.name}
                        className={`${folder.type === TreeItemType.folder ? DriveEntryIcons.Folder : DriveEntryIcons.Shared_Folder} ${folder.starred ? DriveEntryIcons.Starred : ""}`} />
                </>
        }
    </>;
}
export default React.memo(TreeFolderIcon);
